import React from 'react';

interface Props {
  isPulling: boolean;
  isRefreshing: boolean;
  pullDistance: number;
  pullThreshold: number;
}

const PullToRefreshIndicator: React.FC<Props> = ({ isPulling, isRefreshing, pullDistance, pullThreshold }) => {
  if (!isPulling && !isRefreshing) return null;

  const progress = Math.min(pullDistance / pullThreshold, 1);

  return (
    <div
      className="flex justify-center items-center transition-all duration-200"
      style={{ height: isPulling ? `${pullDistance}px` : isRefreshing ? '48px' : '0px', overflow: 'hidden' }}
    >
      <div className={`transition-transform ${isRefreshing ? 'animate-spin' : ''}`} style={{ transform: `rotate(${progress * 360}deg)` }}>
        <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182" />
        </svg>
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
